/**
 * Asynchronously loads the component for ClassWidgetContainer
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./ClassWidgetContainer'),
  loading: () => null,
});
